<template>
  <div>
    <b-form-group label="" v-if="this.createChild">
      <div class="d-flex justify-content-between">
        <b-form-radio
          class="mr-2 type-reward-text"
          v-model="rewardType"
          :value="'daily'"
          :name="'daily'"
          >Daily Reward</b-form-radio
        >
        <b-form-radio
          class="type-reward-text"
          v-model="rewardType"
          :value="'long_term'"
          :name="'long_term'"
          >Big Reward</b-form-radio
        >
      </div>
    </b-form-group>

    <b-form-input
      class="mb-3"
      type="text"
      v-model="rewardTitle"
      placeholder="Reward name"
      required
    ></b-form-input>

    <b-form-input
      class="mb-3"
      type="number"
      min="0" 
      v-model="rewardStars"
      :placeholder="this.createChild ? 'Stars required' : 'Points required'"
      required
    ></b-form-input>

    <div v-if="rewardImage && this.createChild ? true : false" class="d-flex flex-column">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="m-0 p-0 h6">Current image:</span>
        <b-link
          class="text-danger small"
          @click="
            () => {
              rewardImage = '';
            }
          "
        >
          X clear image</b-link
        >
      </div>
      <b-img
        fluid
        width="auto"
        height="auto"
        class="rounded radio-select-image mb-3"
        :src="rewardImage"
      ></b-img>
    </div>

    <b-form-file
      v-if="this.createChild"
      accept=".jpg, .jpeg, .png"
      id="file-small"
      class="text-truncate"
      ref="file"
      v-model="file"
      placeholder="Reward image"
    ></b-form-file>
    <b-alert v-model="showDismissibleAlert" variant="danger" class="small" dismissible>
      The image is over 2MB. Please try again.
    </b-alert>
    <b-col cols="12">
      <b-button
        type="submit"
        variant="warning"
        block
        @click="() => sendData()"
        :disabled="validateForm"
      >
        Save
      </b-button>
    </b-col>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import store from '@/store';
const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
export default {
  props: {
    selectedChild: {
      type: Number,
      value: null,
    },
    afterSend: {
      type: Function,
      value: () => {},
    },
    beforeSend: {
      type: Function,
      value: () => {},
    },
    rewardData: {
      type: Object,
      value: {},
    },
    createChild: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      rewardId: null,
      rewardType: null,
      rewardTitle: null,
      rewardStars: null,
      rewardImage: null,
      file: null,
      showDismissibleAlert: false,
    };
  },
  methods: {
    ...mapActions('rewards', [
      'CreateReward',
      'EditReward',
      'CreateParentReward',
      'EditParentReward',
    ]),
    sendData() {
      const file = this.file;
      if (file) {
        if (file.size > 1024 * 1024 * 2) {
          this.showDismissibleAlert = true;
        } else {
          base64Encode(file)
            .then((value) => {
              if (this.rewardId) {
                this.editReward(value); // edit reward
              } else {
                this.createReward(value);
              }
            })
            .catch((error) => {
              console.log('error', error);
            });
        }
      } else {
        if (this.rewardId) {
          // edit reward
          this.editReward();
        } else {
          this.createReward();
        }
      }
    },
    createReward(value) {
      this.beforeSend();
      let formData = new FormData();
      if (value) formData.append('attachment', value);
      formData.append('name', this.rewardTitle);

      if (this.createChild) {
        formData.append('child', this.selectedChild);
        formData.append('reward_type', this.rewardType);
        formData.append('stars_required', this.rewardStars);
        this.CreateReward(formData).then(() => {
          this.afterSend();
        });
      } else {
        formData.append('parent', store.getters['user/getUserId']);
        formData.append('points_required', this.rewardStars);
        this.CreateParentReward(formData).then(() => {
          this.afterSend();
        });
      }
      this.restoreValues();
    },
    editReward(value) {
      this.beforeSend();
      let formData = new FormData();
      if (!this.rewardImage && !value) formData.append('attachment', '');
      if (value) formData.append('attachment', value);
      formData.append('id', this.rewardId);
      formData.append('name', this.rewardTitle);

      if (this.createChild) {
        formData.append('child', this.selectedChild);
        formData.append('stars_required', this.rewardStars);
        formData.append('reward_type', this.rewardType);
        this.EditReward(formData).then(() => {
          this.afterSend();
        });
      } else {
        formData.append('parent', store.getters['user/getUserId']);
        formData.append('points_required', this.rewardStars);
        this.EditParentReward(formData).then(() => {
          this.afterSend();
        });
      }

      this.restoreValues();
    },
    restoreValues() {
      // restore default values
      this.rewardType = null;
      this.rewardTitle = null;
      this.rewardStars = null;
      this.rewardId = null;
      this.rewardImage = null;
      this.file = null;
    },
  },
  computed: {
    validateForm() {
      if (
        this.rewardStars > 0 &&
        this.rewardTitle &&
        ((this.createChild && this.rewardType) || !this.createChild)
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    if (this.rewardData) {
      this.rewardId = this.rewardData.id;
      this.rewardTitle = this.rewardData.name;
      this.rewardType = this.rewardData.reward_type;
      this.rewardStars = this.rewardData.stars_required;
      this.rewardImage = this.rewardData.attachment;
    }
  },
  // beforeRouteEnter(to, from, next) {

  // }
};
</script>

<style scoped>
.type-reward-text {
  display: flex;
  align-items: center;
  font-size: 16px;
}
</style>
